// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: 'fx-currencies/archive',
        component: () =>
            import(
                /* webpackChunkName: "settings.fx-currencies" */
                '@/pages/[organisation]/settings/fx-currencies/archive.vue'
            ),
        name: 'settings.fx-currencies.archived-fx-currencies',
        meta: {
            loginRequired: true,
            permission: 'access.accounting.foreign-currency.archive-fx-currencies',
        },
    },
    {
        path: 'fx-currencies/archive/:id',
        component: () =>
            import(
                /* webpackChunkName: "settings.fx-currencies" */
                '@/pages/[organisation]/settings/fx-currencies/archive/[id].vue'
            ),
        name: 'settings.fx-currencies.view-archived-fx-currency',
        meta: {
            loginRequired: true,
            permission: 'access.accounting.foreign-currency.archive-fx-currencies',
        },
    },
    {
        path: 'fx-currencies',
        component: () =>
            import(
                /* webpackChunkName: "settings.fx-currencies" */
                '@/pages/[organisation]/settings/fx-currencies.vue'
            ),
        name: 'settings.fx-currencies.search-fx-currencies',
        meta: {
            loginRequired: true,
            permission: 'access.accounting.foreign-currency.view-fx-currencies',
        },
    },
    {
        path: 'fx-currencies/new',
        component: () =>
            import(
                /* webpackChunkName: "settings.fx-currencies" */
                '@/pages/[organisation]/settings/fx-currencies/new.vue'
            ),
        name: 'settings.fx-currencies.create-fx-currency',
        meta: {
            loginRequired: true,
            permission: 'access.accounting.foreign-currency.create-fx-currency',
        },
    },
    {
        path: 'fx-currencies/:id',
        component: () =>
            import(
                /* webpackChunkName: "settings.fx-currencies" */
                '@/pages/[organisation]/settings/fx-currencies/[id].vue'
            ),
        name: 'settings.fx-currencies.view-fx-currency',
        meta: {
            loginRequired: true,
            permission: 'access.accounting.foreign-currency.view-fx-currencies',
        },
    },
];
